import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';

import InvitarPanel from './components/InvitarPanel';
import { currentPath, N8N_TAG_SLUG } from './utils/routeState';

/**
 * «Invita a alguien» también DENTRO de la categoría (PKG-FORO-UX-HOME-RECURSOS-INVITAR).
 *
 * Desde PKG-FORO-N8N-MEMBER-DESTINO quien ya es miembro aterriza directo en `/t/n8n-chile` —el
 * nav, `/recursos` y la propia página del grupo le mandan ahí— y el panel de invitar vivía SOLO
 * en D7 `/n8n-chile`. Resultado medido por David: un miembro parado en su categoría no tiene
 * ninguna forma de generar una invitación sin saberse la otra ruta. El sitio donde estás es el
 * sitio donde invitas; D7 conserva el suyo.
 *
 * SOLO EN ESA CATEGORÍA, por ruta y no por etiqueta de la store — el mismo argumento que
 * `addProposeCta`: `IndexPage` se rinde también en `/discusiones`, donde no hay etiqueta activa.
 *
 * EN `contentItems`, ENTRE LA TOOLBAR (100) Y LA LISTA (90): el paquete pide el panel ARRIBA del
 * listado de hilos, no enterrado en el sidebar. No se usa `viewItems` literal porque ese ItemList
 * se pinta como `<ul>` de la toolbar (cada item envuelto en `<li>`): una sección con formulario
 * dentro de esa lista sería markup roto y saldría apretada en la fila del ordenador de hilos.
 *
 * QUIÉN LO VE LO DECIDE EL PROPIO PANEL, igual que en D7: `InvitarPanel` pregunta al servidor y
 * devuelve `null` para quien no puede invitar (salvo `unconfirmed`, que tiene arreglo y se
 * explica). Para el anónimo ni siquiera consulta. Aquí no se duplica esa política.
 */
export default function addInvitarPanel() {
  extend(IndexPage.prototype, 'contentItems', function (items: any) {
    if (currentPath() !== app.route('tag', { tags: N8N_TAG_SLUG })) return;

    items.add(
      'umbralInvitar',
      <div className="CmInvitar-index">
        <InvitarPanel />
      </div>,
      95
    );
  });
}
